/* Evera theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var E = window.evera || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- Drawers ---------- */
  var overlay = $('[data-overlay]');
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { el.focus(); }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = E.money_format || '{{amount}} SAR';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return withCommas + '.' + parts[1];
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    var label = $('[data-cart-count-label]'); if (label) label.textContent = '(' + cart.item_count + ')';
    if (!cartDrawer) return;
    var body = $('[data-cart-items]', cartDrawer), foot = $('[data-cart-foot]', cartDrawer);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg><p>' + esc(E.strings.empty) + '</p></div>';
      foot.hidden = true; return;
    }
    body.innerHTML = '<div class="cart-items">' + cart.items.map(function (it, i) {
      var props = '';
      if (it.properties) Object.keys(it.properties).forEach(function (k) {
        if (k.charAt(0) !== '_' && it.properties[k]) props += '<span class="line__opt">' + esc(k) + ': <span dir="ltr">' + esc(it.properties[k]) + '</span></span>';
      });
      var variant = it.variant_title && it.product_has_only_default_variant === false ? '<span class="line__opt">' + esc(it.variant_title) + '</span>' : '';
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '';
      return '<div class="line" data-line="' + (i + 1) + '">' +
        '<a class="line__img" href="' + it.url + '">' + img + '</a>' +
        '<div class="line__info"><a class="line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant + props +
        '<div class="qty qty--sm" style="margin-top:6px"><button type="button" data-line-qty="' + (it.quantity + 1) + '" aria-label="+">+</button><input type="number" value="' + it.quantity + '" min="0" aria-label="qty" data-line-input><button type="button" data-line-qty="' + (it.quantity - 1) + '" aria-label="−">−</button></div></div>' +
        '<div class="line__right"><span class="line__price">' + formatMoney(it.final_line_price) + '</span><button type="button" class="line__remove" data-line-qty="0">' + esc(E.strings.remove) + '</button></div>' +
        '</div>';
    }).join('') + '</div>';
    var total = $('[data-cart-total]', cartDrawer); if (total) total.textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }
  function fetchCart() { return fetch(E.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch(E.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast(E.strings.error); });
  }
  if (cartDrawer) {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-open]');
      if (opener && document.body.className.indexOf('template-cart') === -1) {
        e.preventDefault(); fetchCart().then(renderCart); openDrawer(cartDrawer);
      }
    });
    cartDrawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-qty]'); if (!b) return;
      var line = +b.closest('[data-line]').getAttribute('data-line');
      changeLine(line, +b.getAttribute('data-line-qty'));
    });
    cartDrawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-input]')) return;
      changeLine(+e.target.closest('[data-line]').getAttribute('data-line'), +e.target.value || 0);
    });
  }

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('[data-track]', root), dots = $$('.hero__dot', root), slides = $$('.hero__slide', root);
    if (slides.length < 2) return;
    var idx = 0, timer;
    var speed = (+root.getAttribute('data-speed') || 5) * 1000;
    var auto = root.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      idx = (i + slides.length) % slides.length;
      var rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollTo({ left: (rtl ? -1 : 1) * idx * track.clientWidth, behavior: 'smooth' });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
    }
    function start() { if (!auto) return; stop(); timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    var next = $('[data-next]', root), prev = $('[data-prev]', root);
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = track.clientWidth; var i = Math.round(Math.abs(track.scrollLeft) / w);
        if (i !== idx && i < slides.length) { idx = i; dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); }); }
      }, 80);
    }, { passive: true });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var form = $('[data-product-form]', section);
    var dataEl = $('[data-product-json]', section);
    var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-btn]', form) : null;
    var addLabel = form ? $('[data-add-label]', form) : null;
    var mainImg = $('[data-main-media] img', section);

    function selectedOptions() {
      var groups = {};
      $$('[data-option-input]:checked', section).forEach(function (i) { groups[i.getAttribute('data-option-input')] = i.value; });
      return Object.keys(groups).sort().map(function (k) { return groups[k]; });
    }
    function setPrice(v) {
      $$('[data-price]', section).forEach(function (p) {
        var now = $('[data-price-now]', p); if (now) now.textContent = v.price;
        var was = $('[data-price-was]', p);
        if (v.compare) { if (!was) { was = document.createElement('s'); was.className = 'price__was'; was.setAttribute('data-price-was', ''); p.appendChild(was); } was.textContent = v.compare; was.hidden = false; }
        else if (was) { was.hidden = true; }
      });
    }
    function update() {
      var opts = selectedOptions();
      $$('[data-option-value]', section).forEach(function (s) { var k = +s.getAttribute('data-option-value'); if (opts[k] != null) s.textContent = opts[k]; });
      var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      if (!v) { if (addBtn) { addBtn.disabled = true; addLabel.textContent = E.strings.sold_out; } return; }
      idInput.value = v.id;
      setPrice(v);
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? E.strings.add_to_cart : E.strings.sold_out; }
      if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      // availability hints for single-option products
      if (data.variants.length && opts.length === 1) {
        $$('[data-option-input="0"]', section).forEach(function (inp) {
          var match = data.variants.filter(function (x) { return x.options[0] === inp.value; })[0];
          inp.classList.toggle('is-unavailable', !!match && !match.available);
        });
      }
    }
    $$('[data-option-input]', section).forEach(function (i) { i.addEventListener('change', update); });
    if (data.variants.length > 1) update();

    // thumbnails
    $$('[data-thumb]', section).forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.getAttribute('data-src'); }
        $$('[data-thumb]', section).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });

    // quantity
    $$('[data-qty]', section).forEach(function (q) {
      var input = $('input', q);
      q.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qty-step]'); if (!b) return;
        var n = Math.min(+input.max || 99, Math.max(1, (+input.value || 1) + (+b.getAttribute('data-qty-step'))));
        input.value = n;
      });
    });

    // validation of required custom fields
    function validate() {
      var ok = true;
      $$('[data-required-field]', form).forEach(function (f) {
        var err = f.parentNode.querySelector('[data-field-error]');
        var good = f.value.trim() !== '' && f.checkValidity();
        f.classList.toggle('is-invalid', !good);
        if (err) err.hidden = good;
        if (!good && ok) { f.focus(); ok = false; }
      });
      return ok;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validate()) return;
        var errBox = $('[data-form-error]', form); if (errBox) errBox.hidden = true;
        addBtn.classList.add('is-loading'); addBtn.disabled = true;
        fetch(E.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || E.strings.error);
            return fetchCart().then(function (cart) {
              renderCart(cart);
              if (cartDrawer) openDrawer(cartDrawer); else toast(E.strings.added);
            });
          })
          .catch(function (err) { if (errBox) { errBox.textContent = err.message; errBox.hidden = false; } else toast(err.message); })
          .finally(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
      });
      // dynamic checkout must also respect required fields
      form.addEventListener('click', function (e) {
        if (e.target.closest('.shopify-payment-button') && !validate()) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    // sticky add-to-cart on mobile
    var sticky = $('[data-sticky-buy]', section);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { if (validate()) form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click(); }, 350);
      });
    }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length && el.querySelector('.card')) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort-select]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); window.location.href = url.toString();
    });
  });

  /* ---------- Login / recover toggle ---------- */
  var login = $('[data-login]');
  if (login) {
    var lv = $('[data-login-view]', login), rv = $('[data-recover-view]', login);
    function show(recover) { lv.hidden = recover; rv.hidden = !recover; }
    if (window.location.hash === '#recover') show(true);
    login.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show(true); }
      if (e.target.closest('[data-show-login]')) { e.preventDefault(); show(false); }
    });
  }
  /* ---------- Header search toggle (mobile) ---------- */
  $$('[data-search-toggle]').forEach(function (b) {
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (!panel) return;
    b.addEventListener('click', function () {
      var open = panel.hidden; panel.hidden = !open; b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = panel.querySelector('input'); if (i) i.focus(); }
    });
  });

  /* ---------- Count-up stats ---------- */
  var counters = $$('[data-count-to]');
  if (counters.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, to = +el.getAttribute('data-count-to') || 0, t0 = null, dur = 1200;
        function tick(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(tick); }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }
  /* ---------- Cards showcase ---------- */
  $$('[data-showcase]').forEach(function (root) {
    var track = $('[data-sc-track]', root), slides = $$('[data-sc-slide]', root), panels = $$('[data-sc-panel]', root), dots = $$('[data-sc-dot]', root);
    if (!slides.length) return;
    var idx = 0, timer, userTook = false;
    var speed = (+root.getAttribute('data-speed') || 5) * 1000;
    var auto = root.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(i, scroll) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('aria-selected', k === idx ? 'true' : 'false'); });
      panels.forEach(function (p, k) { p.hidden = k !== idx; });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      if (scroll) {
        var rtl = getComputedStyle(track).direction === 'rtl';
        var sr = slides[idx].getBoundingClientRect(), tr = track.getBoundingClientRect();
        var delta = rtl ? sr.right - tr.right : sr.left - tr.left;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
      }
    }
    function start() { if (!auto || userTook) return; stop(); timer = setInterval(function () { show(idx + 1, true); }, speed); }
    function stop() { clearInterval(timer); }
    function take() { userTook = true; stop(); }
    slides.forEach(function (s, k) { s.addEventListener('click', function () { take(); show(k, true); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { take(); show(k, true); }); });
    track.addEventListener('touchstart', take, { passive: true });
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }, { threshold: 0.3 }) : null;
    if (io) io.observe(root); else start();
  });
})();
